import { DashboardMutatePayload } from '@thingslog/repositories';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DashboardSettingsForm } from '../../forms';
import { DashboardSidebarWidgetCard } from './DashboardSidebarWidgetCard';

interface Props {
  widgetId: string;
  isPersisting: boolean;
  onPersistNewDashboard: (
    payload: DashboardMutatePayload,
    callbacks?: { onSuccess?: () => void }
  ) => void;
  onClose: (widgetId: string) => void;
  onStartTour: () => void;
}

export const DashboardSidebarDashboardAddWidget: FC<Props> = ({
  widgetId,
  isPersisting,
  onPersistNewDashboard,
  onClose,
  onStartTour,
}: Props) => {
  const { t } = useTranslation();

  return (
    <DashboardSidebarWidgetCard
      title={t('dashboard_add_dashboard', 'Add Dashboard')}
      widgetId={widgetId}
      expandable
      onClose={onClose}
      onStartTour={onStartTour}
    >
      <DashboardSettingsForm
        type="create"
        disabled={isPersisting}
        onSubmit={(payload: DashboardMutatePayload): void => {
          onPersistNewDashboard(payload, { onSuccess: () => onClose(widgetId) });
        }}
        onCancel={(): void => {
          onClose(widgetId);
        }}
      />
    </DashboardSidebarWidgetCard>
  );
};
